import { createClient } from '@supabase/supabase-js'
import type { Database } from './database.types'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
    realtime: {
      params: {
        eventsPerSecond: 10,
      },
    },
  }
)

// Helper function to call the governance scan Edge Function
export async function triggerGovernanceScan(
  appName: string,
  mode: 'quick' | 'deep' = 'quick'
) {
  const response = await fetch(import.meta.env.VITE_GOVERNANCE_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${supabaseAnonKey}`,
    },
    body: JSON.stringify({
      app_name: appName,
      mode: mode,
      // In production, this would fetch actual component content
      components: []
    }),
  })

  if (!response.ok) {
    const error = await response.text()
    throw new Error(`Scan failed: ${error}`)
  }

  return response.json()
}

// Realtime subscription for new violations
export function subscribeToViolations(
  callback: (payload: any) => void
) {
  return supabase
    .channel('violations')
    .on(
      'postgres_changes',
      {
        event: 'INSERT',
        schema: 'public',
        table: 'governance_violations',
      },
      callback
    )
    .subscribe()
}

// Realtime subscription for scan updates
export function subscribeToScans(
  callback: (payload: any) => void
) {
  return supabase
    .channel('scans')
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'governance_scans',
      },
      callback
    )
    .subscribe()
}